export default __webpack_public_path__ + "static/media/background_music.e2dda746.png";